import { Stack } from "@mantine/core"
import { useDebouncedValue } from "@mantine/hooks"
import { PaginationState } from "@tanstack/react-table"
import { DEFAULT_PAGE_SIZE } from "@tfg/ui"
import { useEffect, useState } from "react"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { SupplierProductionSites } from "~/pages/Brand/Suppliers/List/SupplierProductionSites/SupplierProductionSites.tsx"
import { useListSuppliersProductionSitesQuery } from "~/pages/Brand/Suppliers/List/supplierHooks.ts"

export const SupplierProductionSitesWrapper = () => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: DEFAULT_PAGE_SIZE,
  })
  const [searchProductionSite, setSearchProductionSite] = useState<string>("")
  const [debouncedProductionSite] = useDebouncedValue<string>(
    searchProductionSite,
    600
  )
  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      pageIndex: 0,
    }))
  }, [debouncedProductionSite])
  const productionSitesQuery = useListSuppliersProductionSitesQuery({
    fetchDataOptions: pagination,
    searchProductionSite: debouncedProductionSite,
  })

  return (
    <Stack gap="md">
      <DataFetchWrapper query={productionSitesQuery}>
        {({ data }) => (
          <Stack gap="xs">
            <SupplierProductionSites
              productionSitesData={data}
              setPagination={setPagination}
              pagination={pagination}
              searchProductionSites={searchProductionSite}
              setSearchProductionSites={setSearchProductionSite}
              debouncedProductionSites={debouncedProductionSite}
            />
          </Stack>
        )}
      </DataFetchWrapper>
    </Stack>
  )
}
